import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import flightReducer from "./FlightBooking/flighBookingReducer";
const rootReducer = combineReducers({
  flights: flightReducer,
});

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware()));

export default store;
